import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { quillFormats, quillModules } from "./infoShared";

const EDITOR_MODE_KEY = "docsEditorMode";

const DocContentEditor = ({
  label = "Content",
  value,
  onChange,
  helpText,
}) => {
  const [mode, setMode] = useState(() => {
    try {
      const saved = localStorage.getItem(EDITOR_MODE_KEY);
      return saved === "html" ? "html" : "visual";
    } catch {
      return "visual";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(EDITOR_MODE_KEY, mode);
    } catch {
      // ignore localStorage failures
    }
  }, [mode]);

  return (
    <div>
      <div className="flex items-center justify-between gap-3 mb-2">
        <label className="block text-sm font-semibold text-slate-700">{label}</label>

        <div className="inline-flex items-center rounded-full border border-slate-300 bg-slate-100 p-1">
          <button
            type="button"
            onClick={() => setMode("visual")}
            className={`px-3 py-1 rounded-full text-xs font-semibold transition-all ${
              mode === "visual"
                ? "bg-slate-900 text-white"
                : "text-slate-700 hover:bg-white"
            }`}
          >
            Visual
          </button>
          <button
            type="button"
            onClick={() => setMode("html")}
            className={`px-3 py-1 rounded-full text-xs font-semibold transition-all ${
              mode === "html"
                ? "bg-slate-900 text-white"
                : "text-slate-700 hover:bg-white"
            }`}
          >
            HTML
          </button>
        </div>
      </div>

      {mode === "visual" ? (
        <div className="rounded-xl border border-slate-300 overflow-hidden bg-white">
          <ReactQuill
            value={value}
            onChange={onChange}
            modules={quillModules}
            formats={quillFormats}
            theme="snow"
          />
        </div>
      ) : (
        <textarea
          value={value || ""}
          onChange={(event) => onChange(event.target.value)}
          spellCheck={false}
          className="w-full min-h-[280px] rounded-xl border border-slate-300 bg-slate-950 text-slate-100 px-3 py-3 text-xs sm:text-sm font-mono focus:outline-none focus:ring-2 focus:ring-sky-300 focus:border-sky-500"
          placeholder="Paste or edit raw HTML here..."
        />
      )}

      <p className="mt-2 text-xs text-slate-500">
        {helpText ||
          "Content is saved as HTML. Use HTML mode to paste/edit raw markup directly."}
      </p>
    </div>
  );
};

export default DocContentEditor;
